import {FC, useRef, useState} from 'react'
import {useDataTableStore} from '../../stores/DataTableStore'
import Swal from 'sweetalert2'
import useAccessToken from '../../hooks/AccessToken'
import {useIntl} from 'react-intl'
import {InvoiceMultiPageSetting} from '../../interfaces/Invoices'
import {deleteInvoices} from '../../api/InvoicesCRUD'
import {Modal} from 'react-bootstrap'
import { mutate } from 'swr'

interface Props {
  showDeleteModal: boolean
  setShowDeleteModal: (value: boolean) => void
  invoice: InvoiceMultiPageSetting
}

const DeleteInvoice: FC<Props> = ({showDeleteModal, setShowDeleteModal, invoice}) => {
  const API_URL = process.env.REACT_APP_API_URL

  const intl = useIntl()
  const token = useAccessToken()
  const {tablesData, setTablesData} = useDataTableStore()
  const [modalBtnLoading, setModalBtnLoading] = useState(false)
  const closeModalRef = useRef<HTMLButtonElement>(null)

  const modalRef = useRef<HTMLDivElement | null>(null)

  const handleDeleteInvoice = async () => {
    // if(!invoice.id) return
    setModalBtnLoading(true)
    try {
      const response = await deleteInvoices(invoice.id!, token)
      if (response.data.success) {
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'ALERT.TITLE.SUCCESS'}),
          text: intl.formatMessage({id: 'FORM.VALIDATION.DELETE_SUCCESS'}),
          heightAuto: false,
        })
        closeModalRef.current?.click()
        setTablesData(
          'invoices',
          tablesData.invoices.filter((data) => data.id !== invoice.id)
        )
        setShowDeleteModal(false)
        mutate(`${API_URL}invoices/settings`)
      }
    } catch (error: any) {
      Swal.fire({
        icon: 'error',
        title: error.response.data.message,
        confirmButtonText: 'Ok',
      })
    } finally {
      setModalBtnLoading(false)
    }
  }

  return (
    <>
      <Modal
        show={showDeleteModal}
        // onHide={handleModalClose}
        centered
        // size='lg'
        // fullscreen="xl-down"
        // style={{width: '1000px'}}
      >
        <Modal.Header closeButton onHide={() => setShowDeleteModal(false)}>
          <Modal.Title>
            {intl.formatMessage({id: 'FORM.ACTION.DELETE'})} {invoice.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            {intl.formatMessage({id: 'FORM.CONFIRMATION'})}{' '}
            {intl.formatMessage({id: 'FORM.ACTION.DELETE'}).toLowerCase()}{' '}
            <strong>{invoice.name}?</strong>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-light'
            data-bs-dismiss='modal'
            onClick={() => setShowDeleteModal(false)}
            ref={closeModalRef}
          >
            {intl.formatMessage({id: 'FORM.ACTION.CANCEL'})}
          </button>
          <button
            type='button'
            className={`btn btn-danger me-10 ${modalBtnLoading ? 'disabled' : ''}`}
            data-kt-indicator={modalBtnLoading ? 'on' : 'off'}
            onClick={handleDeleteInvoice}
          >
            <span className='indicator-label'>
              {intl.formatMessage({id: 'FORM.ACTION.DELETE'})}
            </span>
            <span className='indicator-progress'>
              Loading...{' '}
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          </button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export {DeleteInvoice}
